var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8496C24.8366 32.8496 32 25.6862 32 16.8496C32 8.01305 24.8366 0.849609 16 0.849609C7.16344 0.849609 0 8.01305 0 16.8496C0 25.6862 7.16344 32.8496 16 32.8496Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 22.415L10.4353 31.8548C12.1685 32.498 14.0433 32.8499 16.0004 32.8499C22.8798 32.8499 28.7446 28.5079 31.0052 22.415H9.04395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 11.2844L10.4353 1.84467C12.1685 1.20148 14.0433 0.849609 16.0004 0.849609C22.8798 0.849609 28.7446 5.19161 31.0052 11.2844H9.04395Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8495C0 23.729 4.34206 29.5937 10.4348 31.8544V1.84473C4.34206 4.10541 0 9.9701 0 16.8495Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/flag_united_arab_emirates.aee71b12b19e08a0a265b959407967c0.svg";
export { ForwardRef as ReactComponent };